// removed by extract-text-webpack-plugin
module.exports = {"photoBanner":"style__photoBanner___1G6qB","bananas":"style__bananas___1DJHO","oatmealBananas":"style__oatmealBananas___3THVO","bigRiceSalad":"style__bigRiceSalad___2OznC"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/photoBanner/style.scss
 ** module id = 366
 ** module chunks = 0
 **/